const normalizeKey = (value) =>
  String(value).trim().toLowerCase().replace(/[^a-z0-9]/g, '');

const extractPermissionRaw = (item) => {
  if (item == null) return null;
  if (typeof item === 'string' || typeof item === 'number') return item;
  if (typeof item === 'object') {
    return (
      item.permission_key ??
      item.permission ??
      item.key ??
      item.slug ??
      item.code ??
      item.name ??
      item.permission_name ??
      item.label ??
      item.id ??
      item.permission_id ??
      null
    );
  }
  return String(item);
};

export const buildPermissionResolver = (modulesConfig) => {
  const byNormalized = new Map();

  const register = (raw, canonicalId) => {
    if (raw == null || raw === '') return;
    byNormalized.set(normalizeKey(raw), canonicalId);
  };

  modulesConfig.forEach((module) => {
    module.permissions.forEach((perm) => {
      register(perm.id, perm.id);
      register(perm.label, perm.id);
    });
  });

  return (raw) => {
    const value = extractPermissionRaw(raw);
    if (value == null || value === '') return null;
    return byNormalized.get(normalizeKey(value)) ?? null;
  };
};

export const permissionsToCheckedMap = (permissions, modulesConfig) => {
  const resolve = buildPermissionResolver(modulesConfig);
  const map = {};
  const list = Array.isArray(permissions)
    ? permissions
    : permissions && typeof permissions === 'object'
      ? Object.values(permissions)
      : [];

  list.forEach((item) => {
    const canonicalId = resolve(item);
    if (canonicalId) {
      map[canonicalId] = true;
    }
  });

  return map;
};
